import { createContext } from 'react';

export const SignalRContext = createContext(undefined);
